import {
    /** FETCH APPLICATION  */
    FETCH_DELETEAPPLICATION_FULFILLED,
    FETCH_DELETEAPPLICATION_REJECTED,
    FETCH_DELETEAPPLICATION_PENDING,
    RESET,
} from "../../actions/application/deleteApplication";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DELETEAPPLICATION_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_DELETEAPPLICATION_FULFILLED:
            return {
                ...state,
                deleteApplication: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_DELETEAPPLICATION_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};